import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import {
  Router,
  Route,
  Switch,
  BrowserRouter,
  Redirect,
} from "react-router-dom";
import { ReactComponent as Log } from './Log.svg';
import {
  resetAudieceFilters,
  audienceGetNewFilterData,
} from "ReduxStore/Slices/audienceSlice";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/kapitalwise.scss?v1.4.0";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Login from "views/Login.js";
import { Provider } from "react-redux";
import store, { persistor } from "ReduxStore/store.js";
import { QueryClient, QueryClientProvider, } from 'react-query'
import Reset from "views/Reset.js";
import { ToastContainer, cssTransition } from "react-toastify";
import "animate.css";
import "react-toastify/dist/ReactToastify.min.css";
import ForgotPass from "views/ForgotPass.js";
import { PersistGate } from "redux-persist/integration/react";
import routes from "routes.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import PrivateRoute from "./Utils/PrivateRoute.js";
import { validateRoutesByRole } from "./Utils/Authorization";
import Guide from 'views/UserGuide/Guide'
import Signup from "views/Signup.js";
import AccountSusendedNotification from "views/Notifications/AccountSusendedNotification"
import OnboardPendingNotification from "views/Notifications/OnboardPendingNotification"
import axios from "axios";

import { ReactComponent as LOGOG } from 'assets/img/logo.svg';
import './styles.css'
import { useSelector, useDispatch } from "react-redux";

import { setMenu } from "ReduxStore/Slices/menuSlice";
import { resetWorkflowState } from "ReduxStore/Slices/workflowSlice";
import { resetCampaignData } from "ReduxStore/Slices/campaignSlice";
import { resetTemplateData } from "ReduxStore/Slices/templateSlice";


const AdminLayout = (props) => {
  const [route, setRoute] = React.useState(routes);
  const backgroundColor = "blue";

  const {menu} = useSelector(state => state.menuSlice)
  const dispatch = useDispatch();

  useEffect(() => {
    setRoute(validateRoutesByRole(routes))

    // let path = window.location.pathname;
    // let newMenu = menu.map((item) => {
    //   console.log("ad use",item.url, path)
    //   if (item.url === path) {
    //     return { ...item, selected: true }
    //   } else {
    //     return { ...item, selected: false }
    //   }
    // })
    // if (newMenu.filter((item) => item.selected).length === 0) {
    //   newMenu[0].selected = true
    // }
    // dispatch(setMenu(newMenu))
  }, [props])


  function selectedMenuItem(index) {
    let newMenu = menu.map((item, i) => {

      console.log("ITEM => ", item);

      if (i === index) {
        if (item.name.toLowerCase().includes("aud")){
          console.log("SEO{{{{{{{{{{")
          dispatch(resetAudieceFilters())
          dispatch(audienceGetNewFilterData())
        }

        if (item.name.toLowerCase().includes("workflow")){
          console.log("SEO{{{{{{{{{{")
          if (window.location.pathname.includes("automationstudio")){
            return { ...item, selected: true }
          }
          dispatch(resetWorkflowState());

        }
        
        if (item.name.toLowerCase().includes("create campaign")){
          console.log("SEO{{{{{{{{{{")
          if (window.location.pathname.includes("createAutomation")){
            return { ...item, selected: true }
          }
          dispatch(resetCampaignData());

        }

        if (item.name.toLowerCase().includes("create templates")){
          console.log("SEO{{{{{{{{{{")
          console.log("Click hoo gya!!");
          if (window.location.pathname.includes("info")){
            dispatch(resetTemplateData());
            return { ...item, selected: true }
          }
          dispatch(resetTemplateData());

        }

        if (item.name.toLowerCase().includes("create trigger")){
          console.log("SEO{{{{{{{{{{")
          console.log("Click hoo gya TRIGGER!!");
          if (window.location.pathname.includes("createTrigger")){
            return { ...item, selected: true }
          }
          dispatch(resetTemplateData());

        }

        return { ...item, selected: true }
      } else {
        return { ...item, selected: false }
      }
    })
    dispatch(setMenu(newMenu))
  }
  return (
    <>

    <div className="top-bar-main">
      <a className="main-logo-top" >
        <LOGOG style={{width:"30px"}} />
        <span className="logo-text">KapitalWise</span>
      </a>

      {/* <a className="button" href="/" onClick={()=>{ localStorage.clear(); }}>
        <Log style={{width:"25px",height:"25px",minWidth:"25px" ,display:"inline"}}/>        
        <div className="logout">LOGOUT</div>

        </a> */}
      <div className="menu-items-top">
        {
          menu && menu.map((item, index) => {
            if (!item.allow || item.hide)
              return null

            return (
              <a key={index} href='#' onClick={()=>{
                const hist = createBrowserHistory();

                hist.push(item.url)
                selectedMenuItem(index)
              }}  className={item.selected?"menu-item menu-item-sel ":"menu-item"} >{item.name}</a>
            )
            })
        }
      </div>

    </div>
    <div className="wrapper">
      <Guide />
      <Sidebar
        {...props}
        routes={route}
        backgroundColor={backgroundColor}
      />
      <div className="main-panel">
        <Switch>
          {route.map((prop, key) => {
            return (
              <PrivateRoute
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
        </Switch>
      </div>
    </div>
    </>
  );
}

const queryClient = new QueryClient()
const hist = createBrowserHistory();

axios.interceptors.response.use(
  (response) => {
    return response
  }
  , (error) => {
    if (error?.response?.data.type === "onboardPending") {
      hist.push({ pathname: "/verificationPending", state: { error: error } });
    } else if (error?.response?.data.type === "suspended") {
      hist.push({ pathname: "/accountSuspended", state: { error: error } });
      localStorage.removeItem("token");
    }
    return Promise.reject(error)
  }
)

ReactDOM.render(
  <>
    <div id="cover" style={{ display: "none" }}></div>
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      transition={cssTransition({
        enter: "animate__animated animate__fadeInDown",
        exit: "animate__animated animate__fadeOutUp",
      })}
      limit={1}
    />
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Router history={hist}>


              <Switch>
                <Route
                  path="/admin"
                  render={(props) => <AdminLayout {...props} />}
                />
                <Route path="/forgotPassword" component={ForgotPass} />
                <Route path="/passwordReset" component={Reset} />
                <Route path="/signup" component={Signup} />
                <Route path="/accountSuspended" component={AccountSusendedNotification} />
                <Route path="/verificationPending" component={OnboardPendingNotification} />
                <Route
                  path="/login"
                  component={Login}
                />
                <Redirect from="/" to="/login" />
              </Switch>

            </Router>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </>,

  document.getElementById("root")
);
